import React from 'react';
import DetailsPortal from './DetailsPortal';
import './OrderDetailsPanel.css';

const TransactionDetailsPanel = ({ transaction, onClose }) => {
  if (!transaction) return null;

  const getFirstValue = (keys) => {
    for (const key of keys) {
      const value = transaction[key];
      if (value !== null && value !== undefined && value !== '') {
        return value;
      }
    }
    return null;
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(timestamp * 1000);
      if (isNaN(date.getTime())) {
        const date2 = new Date(timestamp);
        if (isNaN(date2.getTime())) return String(timestamp);
        return formatCustomDate(date2);
      }
      return formatCustomDate(date);
    } catch {
      return String(timestamp);
    }
  };

  const formatCustomDate = (date) =>
    `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()} ${String(
      date.getHours()
    ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

  const formatType = () => {
    const rawType = getFirstValue(['type', 'Type', 'action', 'Action', 'source', 'Source']);
    if (!rawType) return 'Deposit';

    const normalized = String(rawType).toLowerCase();
    if (normalized.includes('deposit') || normalized.includes('balanceadd')) return 'Deposit';
    if (normalized.includes('withdraw') || normalized.includes('balancesubtract')) return 'Withdrawal';
    return String(rawType)
      .replace(/[_-]+/g, ' ')
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  const transactionId = getFirstValue([
    'txId', 'TxId', 'transactionId', 'TransactionId', 'hash', 'Hash', 'ref'
  ]) || 'Transaction';
  const created = formatDate(
    getFirstValue(['create_time', 'Created', 'createdAt', 'blockTimestamp'])
  );
  const amount = getFirstValue(['amount', 'Amount', 'amountUsdt', 'AmountUsdt']);
  const token = getFirstValue(['token', 'Token', 'currency', 'Currency']) || 'USDT';
  const from = getFirstValue(['from', 'From', 'fromAddress', 'FromAddress']) || '-';
  const network = getFirstValue(['network', 'Network']) || '-';
  const statusText = getFirstValue(['Status', 'status']);
  const status = String(statusText || '').toLowerCase();

  return (
    <DetailsPortal>
    <div className="order-details-overlay" onClick={onClose}>
      <div className="order-details-panel" onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <h2>Transaction Details</h2>
          <button type="button" className="close-button" onClick={onClose}>Close</button>
        </div>
        <div className="order-details-content">
          <div className="order-summary">
            <div className="summary-main">
              <span className="summary-label">Transaction</span>
              <span className="summary-primary">{transactionId}</span>
              <span className="summary-secondary">{created}</span>
            </div>
            <div className="summary-chips">
              <span className="status-badge">{formatType()}</span>
              {statusText && (
                <span className={`status-badge status-${status}`}>{statusText}</span>
              )}
            </div>
          </div>

          <div className="detail-section">
            <h3>Details</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Type</span>
                <span className="detail-value">{formatType()}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Amount</span>
                <span className="detail-value">{amount === null ? '-' : `${amount} ${token}`}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Created</span>
                <span className="detail-value">{created}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">From</span>
                <span className="detail-value">{from}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Network</span>
                <span className="detail-value">{network}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </DetailsPortal>
  );
};

export default TransactionDetailsPanel;
